import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { StudentListPage } from '@/pages/StudentListPage'
import { StudentFormPage } from '@/pages/StudentFormPage'
import { StudentDetailPage } from '@/pages/StudentDetailPage'
import { KYCQueuePage } from '@/pages/KYCQueuePage'
import { HomeworkListPage } from '@/pages/HomeworkListPage'
import { HomeworkFormPage } from '@/pages/HomeworkFormPage'
import { HomeworkDetailPage } from '@/pages/HomeworkDetailPage'
import { AttendancePage } from '@/pages/AttendancePage'
import { StudentImportPage } from '@/pages/StudentImportPage'
import { AttendanceEditPage } from '@/pages/AttendanceEditPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { OrientationSetupPage } from '@/pages/OrientationSetupPage'
import { OrientationLivePage } from '@/pages/OrientationLivePage'
import { OrientationQRPage } from '@/pages/OrientationQRPage'
import { OrientationDashboardPage } from '@/pages/OrientationDashboardPage'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import './index.css'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/students"
          element={
            <ProtectedRoute>
              <StudentListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/students/:studentId"
          element={
            <ProtectedRoute>
              <StudentDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/students/import"
          element={<ProtectedRoute><StudentImportPage /></ProtectedRoute>}
        />
        <Route
          path="/students/new"
          element={
            <ProtectedRoute>
              <StudentFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/students/:studentId/edit"
          element={
            <ProtectedRoute>
              <StudentFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/homework"
          element={<ProtectedRoute><HomeworkListPage /></ProtectedRoute>}
        />
        <Route
          path="/homework/new"
          element={<ProtectedRoute><HomeworkFormPage /></ProtectedRoute>}
        />
        <Route
          path="/homework/:homeworkId"
          element={<ProtectedRoute><HomeworkDetailPage /></ProtectedRoute>}
        />
        <Route
          path="/attendance"
          element={<ProtectedRoute><AttendancePage /></ProtectedRoute>}
        />
        <Route
          path="/attendance/:date/edit"
          element={<ProtectedRoute><AttendanceEditPage /></ProtectedRoute>}
        />
        <Route
          path="/orientation/setup"
          element={<ProtectedRoute><OrientationSetupPage /></ProtectedRoute>}
        />
        <Route
          path="/orientation/:eventId"
          element={<ProtectedRoute><OrientationLivePage /></ProtectedRoute>}
        />
        <Route
          path="/orientation/:eventId/qr/:studentId"
          element={<ProtectedRoute><OrientationQRPage /></ProtectedRoute>}
        />
        <Route
          path="/orientation/:eventId/dashboard"
          element={<ProtectedRoute><OrientationDashboardPage /></ProtectedRoute>}
        />
        <Route
          path="/settings"
          element={<ProtectedRoute><SettingsPage /></ProtectedRoute>}
        />
        <Route
          path="/kyc"
          element={
            <ProtectedRoute>
              <KYCQueuePage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
